import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track"]

  connect() {
    this.position = 0
    this.updateVisibleCards()
    this._onResize = () => {
      this.updateVisibleCards()
      this.clampPosition()
    }
    window.addEventListener("resize", this._onResize)
  }

  disconnect() {
    window.removeEventListener("resize", this._onResize)
  }

  updateVisibleCards() {
    const w = window.innerWidth
    if (w < 576) {
      this.visibleCards = 2
    } else if (w < 992) {
      this.visibleCards = 2
    } else {
      this.visibleCards = 4
    }
  }

  clampPosition() {
    const maxPos = this.trackTarget.children.length - this.visibleCards
    if (this.position > maxPos) this.position = Math.max(0, maxPos)
    this.updatePosition()
  }

  left() {
    if (this.position > 0) {
      this.position--
      this.updatePosition()
    }
  }

  right() {
    const maxPos = this.trackTarget.children.length - this.visibleCards
    if (this.position < maxPos) {
      this.position++
      this.updatePosition()
    }
  }

  updatePosition() {
    const card = this.trackTarget.children[0]
    const gap = parseFloat(getComputedStyle(this.trackTarget).gap) || 0
    const offset = this.position * (card.offsetWidth + gap)
    this.trackTarget.style.transform = `translateX(-${offset}px)`
  }
}
